import { FormikErrors, FormikTouched } from "formik";

function ErrorMessageV2({
  message,
  touched = false,
  hint,
}: {
  message?:
    | string
    | FormikErrors<any>
    | string[]
    | FormikErrors<any>[]
    | undefined;
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
  hint?: string;
}) {
  const renderMessage = () => {
    if (!touched || !message) return null;

    if (typeof message === "string") {
      return message;
    }

    if (Array.isArray(message)) {
      return message.join(", ");
    }

    return null;
  };
  const error = renderMessage();
  return (
    <>
      {error ? (
        <div className="error-message-text-v2">{error}</div>
      ) : hint ? (
        <div className="hint-message-text-v2">{hint}</div>
      ) : null}
    </>
  );
}
export default ErrorMessageV2;
